export default __webpack_public_path__ + "static/media/icn-user-drk.138dae30.svg";